<!-- 欠费待补交发送 -->
<template>
  <div class="fee-owe-send" data-test="fee-owe-send">
    <div class="receiver"><span class="re">接收人：</span>{{ stusText }}</div>
    <div class="t1">家长收到的微信消息示例</div>
    <div class="t2">学员姓名、交费项目、学校名称、补交费用，将根据实际情况推送。</div>
    <div class="example-wrap">
      <img
        class="img"
        src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/00117.png"
      />
      <div class="tips">
        如家长未绑定账号，将无法接收到提醒通知。<br />
        <span
          class="link"
          @click="app.x3.picker.notifyBindAccount()"
          >通知家长绑定</span
        >
      </div>
    </div>
    <div class="footer">
      <van-button
        square round
        block
        type="primary"
        @click="send"
        loading-text="发送中..."
        :loading="isSubmit"
        data-test="fee-owe-send-btn-send"
        >确认发送</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageTitle: "发送补交提醒",
      isSubmit: false,
    }
  },
  computed: {
    stusText: function () {
      let sts = this.stus,
        text = "";
      if (sts.length == 1) {
        text = sts[0].buyerName;
      } else if (sts.length > 1) {
        text = `${sts[0].buyerName} 等${sts.length}人`;
      }
      return text;
    },
  },
  methods: {
    send() {
      if (this.stus.length == 0) {
        this.$toast.fail("请选择要发送补交提醒的学员");
        return;
      }
      this.isSubmit = true;
      this.showLoading();
      this.$api
        .sendFeeOweNotice({
          type: 0,
          feeOweIds: this.stus.map((item) => {
            return item.id;
          }),
        })
        .then((res) => {
          if (res.code == 200) {
            this.$toast.success( '发送成功' );
            setTimeout(() => {
              app.vue.$emit("refresh-fee-owe-list");
              this.$router.back();
            }, 300);
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .finally(() => {
          vant.Toast.clear();
          this.isSubmit = false;
        });
    }
  },
  created() {
    this.stus = this.$route.params.receiver || [];
  },
}
</script>

<style lang="scss" scoped>
.fee-owe-send {
  .receiver {
    padding: calc(var(--gap) * 16);
    background-color: var(--white);
    color: var(--g7);
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
  }
  .t1 {
    margin: calc(var(--gap) * 12) calc(var(--gap) * 16) calc(var(--gap) * 4)
      calc(var(--gap) * 16);
    color: var(--g8);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
  }
  .t2 {
    margin: 0 calc(var(--gap) * 16) calc(var(--gap) * 12) calc(var(--gap) * 16);
    color: var(--g6);
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
  }
  .example-wrap {
    text-align: center;
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16) calc(var(--gap) * 20)
      calc(var(--gap) * 16);
    background-color: var(--white);
    .img {
      width: 310px;
    }
    .tips {
      margin-top: calc(var(--gap) * 16);
      color: var(--g6);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      text-align: left;
      .link {
        color: var(--tlc);
      }
    }
  }
  .footer {
    margin: calc(var(--gap) * 43) calc(var(--gap) * 16) calc(var(--gap) * 16)
      calc(var(--gap) * 16);
  }
}
</style>